<template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="$router.push({ name: 'vehicles-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i> Créer
        </button>
      </div>
    </div>

    <vue-data-table v-if="vehicles.length" :headers="headers" :data="vehicles" :items-per-page="10"
      :buttons="buttons" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence Nº", class: "fw-bold" },
        { field: "matricule", label: "Numéro d’immatriculation", class: "" },
        // { field: "manufacturerName", label: "Marque", class: "" },
        // { field: "modelName", label: "Modèle", class: "" },
        // { field: "yearManufacture", label: "Année de fabrication", class: "" },
        { field: "user.name", label: "Créer par", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn btn-info",
          action: (vehicle) => {
            this.$router.push({
              name: "vehicles-details",
              params: { reference: vehicle.reference },
            });
          },
        },
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (vehicle) => {
            this.$router.push({
              name: "vehicles-edit",
              params: { reference: vehicle.reference },
            });
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (vehicle) => {
            this.deleteVehicle(vehicle);
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("vehicle", { vehicles: "getVehicles" }),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("vehicle/getAll");
    },
    async deleteVehicle(vehicle) {
      if (confirm("Voulez-vous vraiment supprimer ce véhicule ?")) {
        await this.$store.dispatch("vehicle/delete", vehicle.reference);
        this.refresh();
      }
    },
  },
};
</script>
